export default "__VITE_ASSET__8cf91867__"